import { render, staticRenderFns } from "./PasswordRules.vue?vue&type=template&id=21bcda3d&lang=pug&"
import script from "./PasswordRules.vue?vue&type=script&lang=js&"
export * from "./PasswordRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports